<!-- Self-gated: renders nothing until a newer deploy is detected. -->
@if (appUpdate.updateAvailable()) {
  <div
    class="update-pill"
    role="status"
    aria-live="polite"
    data-testid="app-update-pill">
    <paper-icon name="refresh" [size]="16" aria-hidden="true" />
    <span class="update-pill__text">{{ 'shell.app_shell.update_available' | transloco }}</span>
    <paper-button
      class="ph-no-capture"
      intent="primary"
      size="xs"
      [ariaLabel]="'shell.app_shell.update_refresh_aria' | transloco"
      (click)="refresh()">{{ 'shell.app_shell.update_refresh' | transloco }}</paper-button>
  </div>
}
